export default __webpack_public_path__ + "static/media/rpa-service.5a4c0b54.jpeg";